module.exports = __webpack_public_path__ + "static/media/Formular-Bold.0c683b1e.ttf";